module.exports = __webpack_public_path__ + "db4298f9a20a9c29739d2711715c3e64.png";